import { SpacingComponent } from '@varo/graphql-schema-types';
import React from 'react';
import { View } from 'react-native';
import { getVXLSpacing } from 'shared/utils/getVXLSpacing/getVXLSpacing';

export const VXLSpacing = (element: SpacingComponent) => {
  const vxlSpacing = getVXLSpacing(element.spacing);
  return <View key={element.id} style={{ height: vxlSpacing }} />;
};
